import { render, staticRenderFns } from "./category-nav.vue?vue&type=template&id=6867bd18&scoped=true&"
import script from "./category-nav.vue?vue&type=script&lang=js&"
export * from "./category-nav.vue?vue&type=script&lang=js&"
import style0 from "./category-nav.vue?vue&type=style&index=0&id=6867bd18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867bd18",
  null
  
)

export default component.exports